// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__21_KW","colCheckbox":"styles_colCheckbox__2stzh"};